import React, { useEffect } from 'react'
import { useLocation,useNavigate } from 'react-router-dom'
import {RiListCheck} from 'react-icons/ri';
import {AiOutlineControl} from 'react-icons/ai';

function BillsMenu() {

  const {pathname} = useLocation()

  // console.log("pathanme",pathname)

  const navigator = useNavigate()

 

  const menu1 = [
    {name:'Total Bills',icon:RiListCheck,path:'/bills/list',id:1,color:''},
  ] 

 useEffect(()=>{
  if(pathname === '/bills'){
    navigator('list')
  }
 },[])
  
  return (
    <div className='md:w-44 md:border-r md:h-screen overflow-y-hidden'>

       

        <div className='mb-4 mx-3  md:pt-4 mx-1'>
        <h6 className='mb-2 font-[700] hidden md:block text-[12px]'>Basic Option</h6>
            <div className='flex  md:block w-auto'>
            {menu1.map((m,i)=>(
                <div key={m?.path} className={`flex ${i === 0 && 'min-w-[120px]'}  pr-4 md:pr-0 items-center  my-1 hover:bg-[#f4f5f7] px-1.5 py-1.5 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>     
            ))}
            </div>
        </div>

        

       

     

   
    </div>
  )
}

export default BillsMenu